import {
  Directive,
  ElementRef,
  inject,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[fileDnd]',
})
export class FileDndDirective {
  private readonly elRef = inject(ElementRef);

  @Output() files: EventEmitter<FileList> = new EventEmitter();

  @HostListener('dragover', ['$event']) onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  @HostListener('dragenter', ['$event']) onDragEnter(event: DragEvent) {
    event.preventDefault();
    this.elRef.nativeElement.classList.add('dragover');
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.elRef.nativeElement.classList.remove('dragover');
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.elRef.nativeElement.classList.remove('dragover');

    if (event.dataTransfer?.files) {
      this.files.emit(event.dataTransfer.files);
    }
  }
}
